import { useEffect, useState } from "react";

// Msal imports
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionStatus, InteractionType, InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

// Sample app imports
import { OrgChartData } from "../ui-components/OrgChartData";
import { Loading } from "../ui-components/Loading";
import { ErrorComponent } from "../ui-components/ErrorComponent";
import { callMsGraph } from "../utils/MsGraphApiCall";
import { graphConfig } from "../authConfig";

const OrgChartContent = () => {
    const { instance, inProgress } = useMsal();
    const [ orgChartData, setOrgChartData] = useState(null);

    useEffect(() => {
        if (!orgChartData && inProgress === InteractionStatus.None) {
            callMsGraph(graphConfig.graphOrgEndpoint).then(setOrgChartData).catch((e) => {
                if (e instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect({
                        ...loginRequest,
                        account: instance.getActiveAccount()
                    });
                }
            });
        }
    }, [inProgress, orgChartData, instance]);

    return (
        <div style={{ height: '100%', width: '100%' }}>
            { orgChartData ? <OrgChartData orgChartData={orgChartData} /> : null }    
        </div>
    );
};

export function OrgChart() {
    const authRequest = {
        ...loginRequest
    };

    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={authRequest}
            errorComponent={ErrorComponent}
            loadingComponent={Loading}
            style={{display: 'flex'}}
        >
            <OrgChartContent />
        </MsalAuthenticationTemplate>
    )
};